export enum CurrencyEnum {
    HRK = "kn",
    EUR = "eur",
}